import { contentIcons } from './contentIcons'

// Replace `[[icon:NAME]]` tokens with the curated inline SVG from contentIcons. Unknown names are left
// verbatim (visible, so a typo is obvious). Applied at every render site for editorial HTML
// (ContentText, ContentRegion, the inline-editor preview) AFTER server-side sanitization — the
// sanitizer keeps the text token but strips raw <svg>, so this re-inserts trusted glyph markup.
const ICON_TOKEN = /\[\[icon:([a-z0-9-]+)\]\]/gi

export function expandIcons(html: string): string {
  if (!html || html.indexOf('[[icon:') === -1) return html
  return html.replace(ICON_TOKEN, (match, name: string) => contentIcons[name.toLowerCase()] ?? match)
}
